import React from 'react';
import { Grid, Skeleton } from "@mui/material";

export const Loading = (props: { totalBoxes: number }): React.ReactElement => (
  <Grid container spacing={3}>
    {Array.from(Array(props.totalBoxes).keys()).map((j, v) => (
      <Grid item xs={12} key={j}>
        <Skeleton variant="rectangular" height={100} />
      </Grid>
    ))}
  </Grid>
);